<template>

    <b-col >
        <div v-if="mainValues.hasPH">
            <h4>pH</h4>
            <b-row cols="12">
                <b-col cols="3" class="text-left">
                    <!-- acid / base  -->
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.consign") }}:</p>
                </b-col>

                <b-col cols="4" class="text-left" v-if="modulesInfo.modules.ph.type === 'ACID/BASE'">
                    <number-input v-model="PH_HIGH " :step="0.1" :min="(PH_LOW)+0.1" :max="1800" inline center controls size="small"></number-input>
                    <!-- high -->
                    <p class="xs"> {{ $t("messages.high") }}</p>
                </b-col>
                <b-col cols="5" class="text-left" v-if="modulesInfo.modules.ph.type === 'ACID/BASE'">
                    <number-input v-model="PH_LOW" :step="0.1" :min="0" :max="(PH_HIGH)-0.1" inline center controls size="small" ></number-input>
                    <!-- low -->
                    <p class="xs"> {{ $t("messages.low") }}</p>
                </b-col>

                <b-col cols="4" class="text-left" v-if="modulesInfo.modules.ph.type === 'ACID'">
                    <number-input v-model="PH_HIGH " :step="0.1" :min="0" :max="1800" inline center controls size="small"></number-input>
                    <!-- high -->
                    <p class="xs"> {{ $t("messages.high") }}</p>
                </b-col>

                <b-col cols="5" class="text-left" v-if="modulesInfo.modules.ph.type === 'BASE'">
                    <number-input v-model="PH_LOW" :step="0.1" :min="0" :max="(PH_HIGH)-0.1" inline center controls size="small" ></number-input>
                    <!-- low -->
                    <p class="xs"> {{ $t("messages.low") }}</p>
                </b-col>
            </b-row>
        </div>
        <div v-if="mainValues.hasRX" cols="12">
            <span class="divider"></span>
            <h4>rX</h4>
            <b-row >
                <b-col cols="3" class="text-left">
                    <!-- consign  -->
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.consign") }}:</p>
                </b-col>
                <b-col cols="9" class="text-left">
                    <number-input v-model="modulesInfo.modules.rx.status.value" :min="0" :max="1000" inline center controls size="small"></number-input>
                    <!-- current value -->
                    <p class="xs">{{ $t("messages.currentValue") }}: {{modulesInfo.modules.rx.current }}</p>
                </b-col>
            </b-row>
        </div>

        <div v-if="mainValues.hasCD" cols="12">
            <span class="divider"></span>
            <h4>CD</h4>
            <b-row >
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.consign") }}:</p>
                </b-col>
                <b-col cols="9" class="text-left">
                    <number-input v-model="CD" :min="0" :max="40000" inline center controls size="small"></number-input>
                    <p class="xs"> {{ $t("messages.currentValue") }}: {{modulesInfo.modules.cd.current }}</p>
                </b-col>
            </b-row>
        </div> 
        <div v-if="mainValues.hasCL" cols="12">
            <span class="divider"></span>
            <h4>CL</h4>
            <b-row >
                <!--  -->
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.consign") }}:</p>
                </b-col>
                <b-col cols="9" class="text-left">
                    <number-input v-model.number="CL1" :min="0" :max="1000" :step="0.01" inline center controls size="small"></number-input>
                    <p class="xs"> {{ $t("messages.currentValue") }}: {{ parseFloat(modulesInfo.modules.cl.current / 100).toFixed(2) }}</p>
                </b-col>
            </b-row>
        </div> 
    <actions :has-changes="hasChanges" v-on:onSave="onSave" v-on:onCancel="onCancel"></actions>
    </b-col>

</template>

<script>
import Actions from "./utils/Actions";

export default {

    name: 'Consigns',
    components:{
        Actions
    },
    props: {
        poolId:Object
    },
    mounted() {
        let fresh = JSON.parse(JSON.stringify(this.poolId));
        this.modulesInfo = fresh
        this.original = JSON.parse(JSON.stringify(fresh));
    },
    data() {
        return {
            modulesInfo: {
                'modules':{
                    'ph':{
                        'type':0,
                        'status':{
                            'low_value':0,
                            'high_value':0
                        }
                    },
                    'rx':{
                        'status':{
                            'value':0
                        }
                    },
                    'cl':{
                        'status':{
                            'value':0
                        }
                    },
                    'cd':{
                        'status':{
                            'value':0
                        }
                    },
                    'uv':{
                        'status':{
                            'value':0
                        }
                    }
                }
            },
            hasChanges: false,
        }
    },
    methods:{
        onSave() {
            this.$emit('onSave',this.original, this.modulesInfo, 'modules');
            this.original = JSON.parse(JSON.stringify(this.modulesInfo));
            this.hasChanges = false
        },
        onCancel() {
            this.modulesInfo = JSON.parse(JSON.stringify(this.original));
            this.hasChanges = false;
        }
    },
    watch: {
        'modulesInfo': {
            handler(value) {
                this.hasChanges = (JSON.stringify(value) === JSON.stringify(this.original)) ? false : true
            },
            deep: true
        }
    },
    computed: {

        mainValues:{
            get(){
                return this.poolId.main;
            }
        },

        PH_HIGH:{
            get(){
                return Number(parseFloat(this.modulesInfo.modules.ph.status.high_value / 100).toPrecision(2));
            },
            set(newValue) { 
               this.modulesInfo.modules.ph.status.high_value = Number(parseFloat(newValue * 100).toPrecision(2));
                return newValue;  
            }
        },
        PH_LOW:{
            get(){
                return Number(parseFloat(this.modulesInfo.modules.ph.status.low_value / 100).toPrecision(2));
            },
            set(newValue) { 
                this.modulesInfo.modules.ph.status.low_value = Number(parseFloat(newValue * 100).toPrecision(2));
                return newValue;  
            }
        },
        CL1:{
            get(){
                return Number(parseFloat(this.modulesInfo.modules.cl.status.value/ 100));
            },
            set(newValue) { 
                this.modulesInfo.modules.cl.status.value = parseInt(newValue * 100)
                return newValue;  
            }
        },
        CD:{
            get(){
                return Number(parseInt(this.modulesInfo.modules.cd.status.value));
            },
            set(newValue) { 
                this.modulesInfo.modules.cd.status.value = newValue
                return newValue;  
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Consigns.vue